import {useRecoilValueLoadable} from 'recoil';
import {deviceTypesMyDictQuery} from '../../../../../store/deviceTypes/selectors';
import {useCallback, useEffect} from 'react';
import {LoadableHelpers} from '../../../../../shared/helpers/loadableHelpers';
import {useEventBus} from '../../../../../hooks/useEventBus';
import {useDashboardTabsStore} from '../store/useDashboardTabsStore';
import {prepareDashboardTabs} from '../helpers';
import {ServiceTypesDictDto} from '../../../../../shared/types/api-v2.types';

export const useDeviceTypesDataGate = () => {
  const data = useRecoilValueLoadable(deviceTypesMyDictQuery);
  const bus = useEventBus();

  const {setIsLoading, setTabs, setActiveTab} = useDashboardTabsStore();

  const handleSuccessData = useCallback(
    (data: ServiceTypesDictDto[]) => {
      const tabs = prepareDashboardTabs(data);
      setTabs(tabs);
      setActiveTab(tabs?.[0]?.value);
      setIsLoading(false);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setTabs, setActiveTab],
  );

  useEffect(() => {
    LoadableHelpers.handle(data, {
      success: handleSuccessData,
      loading: () => setIsLoading(true),
      error: (key, params) => {
        setIsLoading(false);
        bus?.emit(key, params);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bus, data, setTabs, setIsLoading]);
};
